<template>
  <PageTemplate>
    <TitleWidget>Vídeos</TitleWidget>

    <LoadingWidget v-if="loading" />

    <transition name="fade">
      <div v-if="!loading" class="mt-8 mt-md-10">
        <v-row v-if="items.length">
          <v-col
            cols="12"
            sm="6"
            md="4"
            v-for="(item, key) in items"
            :key="key"
          >
            <VideosCard v-bind="item" />
          </v-col>

          <v-col v-if="pagesLength > 1" class="mt-10" cols="12">
            <v-pagination
              v-model="page"
              :length="pagesLength"
              :total-visible="totalVisibles"
            ></v-pagination>
          </v-col>
        </v-row>

        <v-alert v-else type="warning" class="mt-10">
          Nenhum item adicionado até o momento.
        </v-alert>
      </div>
    </transition>
  </PageTemplate>
</template>

<script>
import PageTemplate from "../components/templates/PageTemplate.vue";
import TitleWidget from "../components/widgets/TitleWidget.vue";
import { formatToURL } from "../utils/formatToURL";
import LoadingWidget from "../components/widgets/LoadingWidget.vue";
import { getYoutubeCode } from "../utils/getYoutubeCode";
import VideosCard from "../components/cards/VideosCard.vue";

const _config = {
  path: "/videos",
  mod: "videos",
};
export default {
  data: () => ({
    loading: true,
    items: [],
    path: _config.path,
    itemsPerPage: 24,
    totalItems: 0,
  }),
  computed: {
    page: {
      get() {
        const p = this.$route.query.p;
        return p ? parseInt(p) : 1;
      },
      set(v) {
        const query = { ...this.$route.query };
        query.p = v;
        return this.$router.push({ query });
      },
    },
    pagesLength() {
      return Math.ceil(this.totalItems / this.itemsPerPage);
    },
    totalVisibles() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 1;
        case "sm":
          return 5;
        default:
          return 9;
      }
    },
  },
  created() {
    this.get();
  },
  watch: {
    page() {
      this.get();
    },
    $route() {
      this.get();
    },
  },
  methods: {
    get() {
      const params = {
        itemsPerPage: this.itemsPerPage,
        returnTotalItems: 1,
      };
      if (this.page) params.page = this.page;
      this.loading = true;
      this.$rest(_config.mod)
        .get({
          params,
          keepCache: true,
          save: (state, { totalItems, list }) => {
            this.items = list
              .filter((item) => item.title && item.video)
              .map(({ id, title, video }) => ({
                title,
                img: `https://img.youtube.com/vi/${getYoutubeCode(
                  video
                )}/sddefault.jpg`,
                to: `${this.path}/${formatToURL(title)}-${id}`,
              }));
            this.totalItems = totalItems;
            if (!list.length && this.page > 1) this.page = 1;
          },
        })
        .then(() => (this.loading = false));
    },
  },
  components: {
    PageTemplate,
    TitleWidget,
    LoadingWidget,
    VideosCard,
  },
};
</script>
